export class UserNotFoundError extends Error {
  constructor() {
    super('User Not Found')
    Object.setPrototypeOf(this, UserNotFoundError.prototype)
  }
}
